import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "./lib/cn";

export type FileInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

/**
 * Dosya seçici — `Input`/`Select`/`Textarea` ile aynı aile ama tarayıcı bir dosya
 * girdisinin İÇ yapısını (buton + dosya adı) tek bir `<input type="file">` ile çiziyor;
 * `Input`'un metin alanı stiline uydurmak için yalnız "Dosya Seç" düğmesi Tailwind
 * `file:` varyantlarıyla token'lara bağlanıyor — kutunun kendisi bir Input KOPYASI değil,
 * tarayıcı bunu her zaman kendi mantığıyla çiziyor.
 */
export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(function FileInput(
  { className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type="file"
      className={cn(
        "block w-full text-sm text-fg-muted",
        "file:mr-3 file:h-9 file:rounded-md file:border file:border-border-default file:bg-surface",
        "file:px-3.5 file:text-sm file:font-semibold file:text-fg-strong",
        "file:transition-colors hover:file:bg-muted",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        className,
      )}
      {...rest}
    />
  );
});
